import * as R from 'ramda';
import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import { therapeuticCategoriesCreateRoute } from 'App/common/routeLookup';
import { catchPhrase } from '../config/config';
import PageHeader from '../styles/PageHeader/PageHeader';
import PageTitle from '../styles/PageTitle/PageTitle';
import PageWrapper from '../styles/PageWrapper/PageWrapper';
import TherapyTable from './TherapyTable';
import useFetchAdminTherapyCategoriesQuery from 'App/hooks/useFetchAdminTherapyCategoriesQuery';

const propTypes = {};

const defaultProps = {};

function CategoryListPage() {
    const { data, isLoading } = useFetchAdminTherapyCategoriesQuery();

    const therapies = useMemo(() => {
        if (data && !isLoading) {
            return R.values(data);
        }
        return [];
    }, [data, isLoading]);

    return (
        <>
            <Helmet>
                <title>Therapeutic Categories - {catchPhrase}</title>
            </Helmet>

            <PageTitle>Therapeutic Categories</PageTitle>

            <PageWrapper>
                <PageHeader style={{ justifyContent: 'flex-end' }}>
                    <Link to={therapeuticCategoriesCreateRoute} className="btn btn-primary">
                        <FaPlus /> Create Therapeutic Category
                    </Link>
                </PageHeader>

                <TherapyTable data={therapies} isLoading={isLoading} />
                <div style={{ marginTop: '0.25rem' }}>
                    <Link to="/add-medication">+ Add Medication</Link>
                </div>
            </PageWrapper>
        </>
    );
}

CategoryListPage.propTypes = propTypes;
CategoryListPage.defaultProps = defaultProps;

export default CategoryListPage;
